// @flow
import React from "react"

import Button from "../Button/Button"
import Translate from "../../../../app/scripts/components/Translate"

type Props = {
  recoverText: HTMLElement | string | null,
  chatEnabled: boolean,
  handleOpenChat: Function, // eslint-disable-line flowtype/no-weak-types
}

const DelayedChatFooter = ({ recoverText, chatEnabled, handleOpenChat }: Props) => (
  <div className="DelayedChatFooter">
    {recoverText && (
      <span
        className="DelayedChatFooter-content"
        dangerouslySetInnerHTML={{ __html: recoverText }}
      />
    )}
    {chatEnabled && (
      <Button onClick={handleOpenChat} fullwidth={!recoverText}>
        <Translate tKey="booking.abandonment.help.chat_action" />
      </Button>
    )}
  </div>
)

export default DelayedChatFooter
